'use strict';

require('./../__name/user-account__name.react.js');

require('./../__name/_has-accent-letter/user-account__name_has-accent-letter_yes.react.js');